var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineMyLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1 2.03293C13.1 1.46246 12.6075 1 12 1C11.3925 1 10.9 1.46246 10.9 2.03293V4.65592C7.67985 5.13413 5.13413 7.67985 4.65592 10.9H2.03293C1.46246 10.9 1 11.3925 1 12C1 12.6075 1.46246 13.1 2.03293 13.1H4.65592C5.13413 16.3202 7.67985 18.8659 10.9 19.3441V21.9671C10.9 22.5375 11.3925 23 12 23C12.6075 23 13.1 22.5375 13.1 21.9671V19.3441C16.3202 18.8659 18.8659 16.3202 19.3441 13.1H21.9671C22.5375 13.1 23 12.6075 23 12C23 11.3925 22.5375 10.9 21.9671 10.9H19.3441C18.8659 7.67985 16.3202 5.13413 13.1 4.65592V2.03293ZM12 17.5C8.96243 17.5 6.5 15.0376 6.5 12C6.5 8.96243 8.96243 6.5 12 6.5C15.0376 6.5 17.5 8.96243 17.5 12C17.5 15.0376 15.0376 17.5 12 17.5ZM13.375 12C13.375 12.7594 12.7594 13.375 12 13.375C11.2406 13.375 10.625 12.7594 10.625 12C10.625 11.2406 11.2406 10.625 12 10.625C12.7594 10.625 13.375 11.2406 13.375 12ZM15.3 12C15.3 13.8225 13.8225 15.3 12 15.3C10.1775 15.3 8.7 13.8225 8.7 12C8.7 10.1775 10.1775 8.7 12 8.7C13.8225 8.7 15.3 10.1775 15.3 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineMyLocation);
export default __webpack_public_path__ + "static/media/line-my-location.9fce1b6ba3331191f045a86906b3b5ea.svg";
export { ForwardRef as ReactComponent };